<template>
  <div class="home">
    <Header />
    <About />
    <Products />
    <Contact />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import About from '@/components/About.vue';
import Products from '@/components/Products.vue';
import Contact from '@/components/Contact.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'Home',
  components: { Header, About, Products, Contact, Footer },
};
</script>
